export default "__VITE_ASSET__BQcj09fP__"